import { AppAction, AppContext } from "helpers/context";
import { GroupLabel } from "helpers/models";
import { useContext, useEffect, useState, useRef } from "react";
import { handleGetMultipleResultGroupData, countTotalCheckedPointIds } from "helpers/groupResultData"
import ShareTable from "components/results/table-modal/share-table/share-table"

interface Props {
  setCount: any;
  locationsTable: any[]
}

const EventImpactTable = ({ setCount, locationsTable }: Props) => {
  const [context, dispatch] = useContext(AppContext);

  const noAnalysisLocationRef = useRef<any[]>([]);
  const [tableData, setTableData] = useState<GroupLabel[]>([]);

  const handleGetTableData = () => {
    if (!context.eventAnalysisStore || !context.eventAnalysisLegend) {
      setTableData([]);
      return;
    }

    const {
      result,
      noAnalysis
    } = handleGetMultipleResultGroupData({
      storeData: context.eventAnalysisStore,
      locationsTableData: locationsTable,
      legendData: context.eventAnalysisLegend,
      needNoData: false,
      needChartData: false
    })
    noAnalysisLocationRef.current = noAnalysis
    setTableData(result[0] || []);
  }

  useEffect(() => {
    if (!tableData) {
      return;
    };
    const count = countTotalCheckedPointIds(tableData)
    setCount(count);
  }, [tableData]);

  useEffect(() => {
    handleGetTableData()
  }, [context.eventAnalysisStore, context.eventAnalysisLegend, locationsTable]);


  if (!tableData) {
    return <></>;
  }

  return (
    <ShareTable
      tableData={tableData}
      activeLegend={0}
      noAnalysisLocationRef={noAnalysisLocationRef}
      analysedLegends={context.eventAnalysisLegend}
      type="event"
    />
  );
};

export default EventImpactTable;
